import type { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { useSessionContext } from 'src/hooks'
import { paths } from 'src/router'

import { AppLoadingScreen } from '../components'

export const AuthGuard = ({ children }: PropsWithChildren) => {
  const { user: isAuthenticated, isLoading } = useSessionContext()

  if (isLoading) {
    return <AppLoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.auth.login} />
  }

  return children
}
